export const brand = {
    
    logo: {
        light: "/assets/images/logos/school-site/ckziu-logo-bw-no-backgrd-gray-111-45.svg",
        dark: "/assets/images/logos/school-site/ckziu-logo-bw-no-backgrd-white-111-45.svg",
    },
    
    lines: [
        "Centrum Kształcenia Zawodowego",
        "i Ustawicznego w Wyrzysku",
    ],
    description: "Oficjalny portal szkoły",
    homepage: "/",
    headingLevel: "h1",
    variants: {
        desktop: {
            headingSize: "xl",
        },
        mobile: {
            headingSize: "lg",
        },
    }
};